import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from 'fuse-ui/components/Typography';
import { withStyles } from '@material-ui/core/styles';

import CanvasCard from '../common/components/canvas-card';
import DomainManagementOverviewContainer from './domain-management/domain-management-overview-container';
import DomainGroupingOverviewContainer from './domain-grouping/domain-grouping-overview-container';

const styles = theme => ( {
    gridContainer: {
        display: 'grid',
        gridColumnGap: `${theme.spacing.unit * 2}px`,
        gridRowGap: `${theme.spacing.unit * 2}px`,
        gridTemplateColumns: 'repeat(3, minmax(440px, auto))',
        marginTop: theme.spacing.unit * 3,
        minHeight: 400,
    },
} );

export const SystemOverview = ( { classes, match } ) => {
    return (
        <Grid container spacing={16} justify="center" alignContent="center" data-automation-id="system-overview-page">
            <Grid item xs={12}>
                <Typography variant="h5">System</Typography>
                <div className={classes.gridContainer}>
                    <DomainGroupingOverviewContainer />
                    <DomainManagementOverviewContainer match={match} />
                    <CanvasCard header={{ title: 'Sender Management' }} automationId="sender-management-overview"/>
                </div>
            </Grid>
        </Grid>
    );
};

SystemOverview.propTypes = {
    classes: PropTypes.object,
    match: PropTypes.shape( {
        url: PropTypes.string
    } ),
};

export default withStyles( styles )( SystemOverview );
